module.exports = __webpack_public_path__ + "static/img/BU01KB.4b1f3fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01KB.jpg
// module id = e2xP
// module chunks = 1